import React from 'react';
import Calendar from 'react-calendar';

import { useDateRangePicker, DateRangeProps } from './hooks/useDateRangePicker';
import {
  CalendarContainer,
  CalendarInputGroup,
  CalendarInput,
  CalendarGroup,
  CalendarOptsContainer,
  CalendarConfirm,
  CalendarCurrent,
  CalendarCancel,
} from './styles';
import 'react-calendar/dist/Calendar.css';

export const DateRangePicker: React.FC<DateRangeProps> = (props: DateRangeProps) => {
  const { updatePeriod, screen, component, maxDate, selectRange, showToday, loadDate } = props;
  const {
    date,
    calendar,
    setCalendar,
    handleClickToday,
    handleConfirmDate,
    onChange,
    updateCalendarState,
    toggleCalendar,
  } = useDateRangePicker({
    updatePeriod,
    screen,
    component,
    maxDate,
    selectRange,
    showToday,
    loadDate,
  });

  return (
    <CalendarContainer>
      <CalendarInputGroup onBlur={toggleCalendar} onClick={toggleCalendar}>
        <CalendarInput readOnly type="text" className="icon-calendar" value={date} />
      </CalendarInputGroup>
      {calendar && (
        <CalendarGroup
          onClick={() => updateCalendarState(true)}
          onBlur={() => updateCalendarState(false)}
        >
          <Calendar
            locale="pt-BR"
            maxDate={new Date()}
            className="input-calendar"
            onChange={onChange}
            selectRange
            onClickDay={() => updateCalendarState(false)}
          />
          <CalendarOptsContainer>
            <CalendarCancel onClick={() => setCalendar(!calendar)}>
              <span>Cancelar</span>
            </CalendarCancel>
            <CalendarCurrent onClick={handleClickToday}>
              <span>Hoje</span>
            </CalendarCurrent>
            <CalendarConfirm onClick={handleConfirmDate}>
              <span>Ok</span>
            </CalendarConfirm>
          </CalendarOptsContainer>
        </CalendarGroup>
      )}
    </CalendarContainer>
  );
};
